import { authGet, authPost } from './http';

// SEC-17/18 — versioned policies and the acceptances a user still owes.

export type PolicyKind = 'terms' | 'privacy' | 'cookies' | 'community';

export interface PolicyDocument {
  id: string;
  kind: PolicyKind;
  version: string;
  locale: string;
  title: string;
  body?: string;
  summary?: string;
  published_at?: string;
  requires_reacceptance: boolean;
  created_at: string;
}

export interface OutstandingPolicy extends PolicyDocument {
  /** The version they accepted before, empty if never. The UI says "we've
   *  updated our terms" or "please accept our terms" on the strength of this —
   *  a first acceptance and a re-acceptance are different conversations. */
  accepted_version?: string;
}

export interface ConsentState {
  outstanding: OutstandingPolicy[];
  accepted: PolicyDocument[];
}

/** What this user still owes, plus what they have already agreed to. */
export const getConsents = (token: string) => authGet<ConsentState>('/me/consents', token);

/** Records acceptance. Idempotent server-side, so a double-tapped button is one
 *  acceptance and the first timestamp is the one kept. */
export const acceptPolicies = (token: string, policyIds: string[]) =>
  authPost<void>('/me/consents', token, { policy_ids: policyIds });
